import request from '@host-panel/request';

type Response = {
  email_connect_disabled: boolean;
  google_connect_disabled: boolean;
  twitter_connect_disabled: boolean;
};

export async function getAuthConfigs(): Promise<Response> {
  return request(`/no/host-panel/auth/configs`, {
    method: 'GET',
    headers: { 'x-auth-version': '2' }
  });
}
